import { render, staticRenderFns } from "./OrgLayout.vue?vue&type=template&id=24d9836d&scoped=true&"
import script from "./OrgLayout.vue?vue&type=script&lang=js&"
export * from "./OrgLayout.vue?vue&type=script&lang=js&"
import style0 from "./OrgLayout.vue?vue&type=style&index=0&id=24d9836d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d9836d",
  null
  
)

export default component.exports